import { Link } from 'react-router-dom';
import ButtonOne from "../../../components/buttons/buttonOne";

export default function IntroRoboticGallery() {
    return (
        <div className="flex flex-col w-full items-center justify-center py-[3rem] xl:py-[5rem] bg-[#4153C5]">
            <div className="flex flex-col xl:flex-row justify-center items-center w-[80%] xl:w-[60%] h-full xl:flex-row xl:items-stretch xl:gap-y-0">
                
                <div className="flex flex-col w-full xl:w-[50%] justify-center items-start gap-y-[1.5rem]">
                    <h2 id="mission-goal" className="flex items-start text-4xl font-bold">
                        A Robotics Kit for <span className="text-[#1BD743] ml-[0.6rem]"> Artists</span>
                    </h2>
                    <img
                        src="/pictures/introRoboticGallery.webp"
                        alt="Takamori Robot engineering kit for education robotics"
                        className="xl:w-[70%] max-w-l h-auto"
                        loading="lazy"
                    />
                </div>

                <div className="flex flex-col w-full xl:w-[50%] gap-y-[2rem]">
                    {/* <div className="flex flex-col gap-y-[1rem] font-xl font-semibold">
                        <p>
                            One thing we noticed over the course of
                            developing H.I.R.O. that we didn’t expect was
                            that H.I.R.O.’s easy assembly and 
                            approachability made, buidling, learning,
                            and interacting with H.I.R.O. a fun activity
                            to do with loved ones.
                        </p>
                        <p>
                            Whether you are introducing your family to your
                            love of science, or want a fun thing to do with 
                            your teens. Turns out building robots is a great
                            way to do both! 
                        </p> 
                    </div> */}


                    <Link to="/gallery" className="mt-[2rem] xl:mt-auto" aria-label="Learn more about our beginner robotics course and engineering kit">
                        <ButtonOne 
                            bgColor="#F32047"
                        >
                            Takamori Gallery
                        </ButtonOne>
                    </Link>
                </div>
            </div>
        </div>
    );
}